const PASSWORD_SALT = 'cKtU2xxQvcQd5gvjetTNikE00smI9IruxYMHF3tP+TI=';
const PASSWORD_HASH = '58997def4571155afe4d7e6740c21b2a47f2fcea00620250d797e16e2eda2fd6';

// Extra hashes from shop.metafields.custom.early_release_code (single value, list, or comma/newline separated)
function getValidHashes() {
  const extra = [].concat(window['EARLY_RELEASE_HASHES'] || [])
    .flatMap((v) => String(v).split(/[\s,]+/))
    .map((v) => v.trim().toLowerCase())
    .filter(Boolean);
  return [PASSWORD_HASH, ...extra];
}

async function hashPassword(str) {
  if (!window.crypto?.subtle) {
    console.error('Web Cryptography API is not supported in this environment.');
    return '';
  }
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str + PASSWORD_SALT));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

const PASSWORD_CODE_KEY = 'passwordCode';

function updateCartPasswordAttribute(isValid, password) {
  const updateUrl = window.Theme?.routes?.cart_update_url || '/cart/update.js';
  const val = isValid ? 'true' : 'false';
  const code = isValid ? (password ?? localStorage.getItem(PASSWORD_CODE_KEY) ?? '') : '';
  const attributes = {
    '_is_valid_password': val,
    '_password': code 
  };

  fetch(updateUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ attributes: attributes })
  }).catch(function (error) {
    console.error('Error updating cart attribute:', error);
  });

  document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
    Object.keys(attributes).forEach(function (key) {
      let input = form.querySelector('input[name="attributes[' + key + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'attributes[' + key + ']';
        form.appendChild(input);
      }
      input.value = attributes[key];
    });
  });
}

window.addEventListener('load', function () {
  const lockPage = document.querySelector('.lock-page');
  if (lockPage && lockPage.classList.contains('lock-page-presale-soldout')) {
    lockPage.style.display = 'block';
    document.body.style.overflow = 'hidden';
    localStorage.setItem('passwordEntered', 'false');
    updateCartPasswordAttribute(false);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const lockPage = document.querySelector('.lock-page');

  if (localStorage.getItem('passwordEntered') === 'true') {
    document.body.classList.add('mystery-box-true');
    if (lockPage) lockPage.style.display = 'none';
    document.body.style.overflow = 'unset';
    updateCartPasswordAttribute(true);
  } else {
    // Show the popup if the password hasn't been entered
    if (lockPage) lockPage.style.display = 'block';
    document.body.style.overflow = 'hidden';
    updateCartPasswordAttribute(false);
  }

  document.addEventListener('keydown', function (event) {
    if (event.target.classList.contains('lock-page-password-input') && event.key === 'Enter') {
      event.preventDefault();
      const btn = document.querySelector('.lock-page-input-button');
      if (btn) btn.click();
    }
  });

  document.addEventListener('click', async function (event) {
    if (!event.target.classList.contains('lock-page-input-button')) return;

    console.log('Clicked on enter password button');
    const inputContent = event.target.closest('.lock-page-input-content');
    const passwordInput = inputContent ? inputContent.querySelector('.lock-page-password-input') : null;
    const password = passwordInput ? passwordInput.value.trim() : '';

    const entered = await hashPassword(password);

    if (entered && getValidHashes().includes(entered)) {
      document.body.classList.add('mystery-box-true');
      if (lockPage) lockPage.style.display = 'none';
      localStorage.setItem(PASSWORD_CODE_KEY, entered);
      localStorage.setItem('passwordEntered', 'true');
      document.body.style.overflow = 'unset';
      updateCartPasswordAttribute(true, entered);
    } else {
      console.log('PASS WRONG');
      updateCartPasswordAttribute(false);
      const lockContent = event.target.closest('.lock-page-content');
      const errorMsg = lockContent ? lockContent.querySelector('.lock-page-error-msg') : null;
      if (errorMsg) {
        errorMsg.style.display = 'block';
        setTimeout(function () {
          errorMsg.style.display = 'none';
        }, 10000);
      }
    }
  });
});



// CLEAR LOCAL STORAGE
(function () {
  const PASSWORD_KEY = 'passwordEntered';
  const EXPIRY_KEY = 'passwordExpiresAt';
  const FIVE_MINUTES = 1 * 60 * 1000;

  const originalSetItem = Storage.prototype.setItem;
  const originalRemoveItem = Storage.prototype.removeItem;

  let expiryTimer;

  function checkPasswordExpiry() {
    clearTimeout(expiryTimer);

    if (localStorage.getItem(PASSWORD_KEY) !== 'true') {
      originalRemoveItem.call(localStorage, EXPIRY_KEY);
      originalRemoveItem.call(localStorage, PASSWORD_CODE_KEY);
      return;
    }

    const expiresAt = Number(
      localStorage.getItem(EXPIRY_KEY)
    );

    const remainingTime = expiresAt - Date.now();

    if (!expiresAt || remainingTime <= 0) {
      originalRemoveItem.call(localStorage, PASSWORD_KEY);
      originalRemoveItem.call(localStorage, EXPIRY_KEY);
      originalRemoveItem.call(localStorage, PASSWORD_CODE_KEY);
      return;
    }

    expiryTimer = setTimeout(
      checkPasswordExpiry,
      remainingTime
    );
  }

  Storage.prototype.setItem = function (key, value) {
    originalSetItem.call(this, key, value);

    if (this === localStorage && key === PASSWORD_KEY) {
      if (String(value) === 'true') {
        originalSetItem.call(
          localStorage,
          EXPIRY_KEY,
          String(Date.now() + FIVE_MINUTES)
        );

        checkPasswordExpiry();
      } else {
        originalRemoveItem.call(localStorage, EXPIRY_KEY);
        originalRemoveItem.call(localStorage, PASSWORD_CODE_KEY);
        clearTimeout(expiryTimer);
      }
    }
  };

  checkPasswordExpiry();

  window.addEventListener('pageshow', checkPasswordExpiry);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      checkPasswordExpiry();
    }
  });
})();